module.exports = __webpack_public_path__ + "img/diente_verde.6a3757c6.svg";